import { render, staticRenderFns } from "./PosHeader.vue?vue&type=template&id=7a306f48&scoped=true"
import script from "./PosHeader.vue?vue&type=script&lang=js"
export * from "./PosHeader.vue?vue&type=script&lang=js"
import style0 from "./PosHeader.vue?vue&type=style&index=0&id=7a306f48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a306f48",
  null
  
)

export default component.exports